/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.PosHardware {
    angular.module("meevo.plugins.posHardware", []);
}